import { loadable } from '@change/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'set-your-password',
		path: '/account_settings/set_your_password',
		component: loadable(
			async () => import(/* webpackChunkName: "pages/account_settings_set__your_password" */ './index'),
			{
				exportName: 'SetYourPassword',
				fallback: Loading,
			},
		),
		restrictedAccess: {
			authOnly: true,
		},
		frame: true,
		ssr: {
			// switch this to true to enable SSR
			enabled: false,
			seo: false,
		},
	},
];
